import React, { FC } from 'react';

import { Paper } from '@material-ui/core';

import { IPlayerProfile } from '../../../../store/player/profile/store';

import { userPic } from '../../../../assets/images';

interface IProps {
  user: IPlayerProfile;
}

const PlayerProfileBasic: FC<IProps> = props => {
  const { user } = props;

  return (
    <div className="player-profile-basic">
      {!!user && !!user.profile && (
        <Paper elevation={1} className={`player-profile-basics-card override `}>
          <div className="left-container">
            <div className="img">
              <img
                src={!!user.profile.image ? user.profile.image : userPic}
                alt={`${user.firstName} ${user.lastName} avatar`}
              />
            </div>
          </div>

          <div className="right-container">
            <h3 className="player-name">{`${user.firstName} ${user.lastName}`}</h3>

            <div className="player-email">
              <p className="label">EMAIL</p>

              <p className="value">{user.email}</p>
            </div>

            <div className="player-ghin">
              <p className="label">GHIN</p>

              <p className="value">{user.profile.ghinNumber}</p>
            </div>
          </div>
        </Paper>
      )}
    </div>
  );
};

export { PlayerProfileBasic };
